import * as CapitalMuiTheme_Theme_components_inputs_MuiAutocomplete from "./MuiAutocomplete.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiButton from "./MuiButton.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiButtonGroup from "./MuiButtonGroup.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiCheckbox from "./MuiCheckbox.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiLoadingButton from "./MuiLoadingButton.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiRadio from "./MuiRadio.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiSelect from "./MuiSelect.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiSlider from "./MuiSlider.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiSwitch from "./MuiSwitch.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiTextField from "./MuiTextField.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiToggleButton from "./MuiToggleButton.js";
import * as CapitalMuiTheme_Theme_components_inputs_MuiToggleButtonGroup from "./MuiToggleButtonGroup.js";
const inputs = {
  ...CapitalMuiTheme_Theme_components_inputs_MuiAutocomplete,
  ...CapitalMuiTheme_Theme_components_inputs_MuiButton,
  ...CapitalMuiTheme_Theme_components_inputs_MuiButtonGroup,
  ...CapitalMuiTheme_Theme_components_inputs_MuiLoadingButton,
  ...CapitalMuiTheme_Theme_components_inputs_MuiRadio,
  ...CapitalMuiTheme_Theme_components_inputs_MuiSelect,
  ...CapitalMuiTheme_Theme_components_inputs_MuiSlider,
  ...CapitalMuiTheme_Theme_components_inputs_MuiSwitch,
  ...CapitalMuiTheme_Theme_components_inputs_MuiTextField,
  ...CapitalMuiTheme_Theme_components_inputs_MuiCheckbox,
  ...CapitalMuiTheme_Theme_components_inputs_MuiToggleButton,
  ...CapitalMuiTheme_Theme_components_inputs_MuiToggleButtonGroup
};
export {
  inputs
};
//# sourceMappingURL=index.js.map
